// extracted by mini-css-extract-plugin
export default {"panel":"JoinOrganization_panel__Ut7cd"};